/**
 * Puente entre `HTTPProxy` —una función suelta, fuera de la inyección de dependencias de Angular—
 * y `TelemetryService`. El proxy pregunta aquí al empezar cada llamada; si la telemetría no está
 * encendida no hay observador y todo es `null`. Nunca lanza: medir no puede romper una llamada.
 */
export interface TelemetryApiCall {
    headers: Record<string, string>;
    end (result: { ok: boolean, status?: number, code?: string }): void;
}

export interface TelemetryApiObserver {
    beginApiCall (name: string): TelemetryApiCall | null;
}

let observer: TelemetryApiObserver | null = null;

export function setTelemetryApiObserver (next: TelemetryApiObserver | null): void {
    observer = next;
}

export function beginTelemetryApiCall (path: string[]): TelemetryApiCall | null {
    try {
        return observer?.beginApiCall(path.join('.')) ?? null;
    } catch {
        return null;
    }
}
